import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router';
import { Alert } from '@/components/ui/Alert';
import { describeError, useVerifyEmail } from '../api';

/**
 * Lands here from the link in the verification email and redeems the token
 * immediately.
 */
export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const verify = useVerifyEmail();
  const attempted = useRef(false);

  useEffect(() => {
    // Tokens are single-use, and StrictMode runs effects twice in development.
    // Without this guard the second run always reports "already used".
    if (!token || attempted.current) {
      return;
    }

    attempted.current = true;
    verify.mutate(token);
  }, [token, verify]);

  return (
    <div className="status-page text-center">
      <img src="/gee-logo.png" alt="" width={881} height={519} className="status-page-mark" />
      <h1 className="text-2xl font-semibold tracking-tight text-surface-50">E-posta doğrulama</h1>

      <div className="mt-6">
        {!token ? (
          <Alert tone="error">Bu bağlantıda doğrulama kodu yok.</Alert>
        ) : verify.isPending ? (
          <p className="text-surface-400" role="status">
            Doğrulanıyor…
          </p>
        ) : verify.isSuccess ? (
          <Alert tone="success">E-posta adresin doğrulandı.</Alert>
        ) : verify.isError ? (
          <Alert tone="error">{describeError(verify.error)}</Alert>
        ) : null}
      </div>

      <Link to="/profile" className="gf-button gf-button-primary mt-8">
        Profilime git
      </Link>
    </div>
  );
}
